export default "__VITE_PUBLIC_ASSET__32bab0ba__"